module.exports = __webpack_public_path__ + "static/media/水体场景制备装置.54eb97d9.png";